// eslint-disable-next-line kf/no-proptype-import
import PropTypes from "prop-types";

export const dynamicObject = PropTypes.objectOf(
  PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.number,
    PropTypes.object,
    PropTypes.array
  ])
);
